var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_32_1483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 151
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.168 75.0824C150.168 33.6159 116.553 0.000732422 75.0863 0.000732422C33.6198 0.000732422 0.00463867 33.6159 0.00463867 75.0824C0.00463867 116.549 33.6198 150.164 75.0863 150.164C116.553 150.164 150.168 116.549 150.168 75.0824Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_32_1483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.168 0.000732422H0.00439453V150.164H150.168V0.000732422Z",
    fill: "#E4DDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79 192.54L120.265 42.7429L101.54 41.4336L91.065 191.231L109.79 192.54Z",
    fill: "#492A7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.298 138.902C57.8846 138.902 71.3307 125.456 71.3307 108.87C71.3307 92.2832 57.8846 78.8372 41.298 78.8372C24.7115 78.8372 11.2654 92.2832 11.2654 108.87C11.2654 125.456 24.7115 138.902 41.298 138.902Z",
    fill: "#937ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.422 100.548L-14.2801 79.6496",
    stroke: "#937ABA",
    strokeWidth: 2.00218
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9651705ad1dcbb1a6bdc13667c687dbb.svg";
export { ForwardRef as ReactComponent };